import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_InstructionScheduling_SSA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Instruction scheduling and software pipelining - static single assignment"
    videos={[
      "https://www.youtube.com/embed/3RJu_njJW2s",
      "https://www.youtube.com/embed/0T2i6He2y5o",
      "https://www.youtube.com/embed/k_myzhuLDk4",
      "https://www.youtube.com/embed/uqTT3gI7KU8",
    ]}
    takeaways={[
      { text: "There are 2 types of example problems in instruction scheduling , practice those questions, mostly those questions will come directly" },
    ]}
    questions={[
      "With a suitable example write a short note on the Instruction Scheduling and Software Pipeling",
      "Create an instruction scheduling algorithm for a multi-core processor that maximizes throughput. Incorporate software pipelining techniques into your design to ensure instructions are executed efficiently in parallel. Use a sample loop computation to demonstrate the execution flow after scheduling.",
      "Explain the role of Instruction Scheduling and Software Pipelining in compiler design with suitable examples and give its significance."
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_InstructionScheduling_SSA;
